module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('general-item', {
    attrs: {
      "format": "minislide"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.in_mini_slider')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.one_small_window_apper')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a64d3178!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/types/items/MiniSlide.vue
 ** module id = 897
 ** module chunks = 1
 **/